import { useEffect } from 'react';
import ActionNotification from '../components/Assets/ActionNotification';
import SectionTitle from '../components/Assets/sectionTitle';

import AdCardContainer from '../features/ad/components/adCardContainer/AdCardContainer';
import useAds from '../features/ad/hooks/useAds';

import { useAppDispatch } from '../App/redux/store';
import InfoBox from '../features/piecework/components/pieceworkPage/InfoBox';
import { pieceworkActions } from '../features/piecework/pieceworkSlice';
import './styles/pieceworkPage.scss';

function PieceworkPage() {
  const {
    ads,
    selectedAds,
    adPagination,
    addItemToSelectedAd,
    loadActiveAd,
    handlePaginationChange,
  } = useAds({});
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(pieceworkActions.setNewTotalAds(0));
    };
  }, []);

  return (
    <main className="piecework">
      <ActionNotification />
      <header className="piecework-header">
        <SectionTitle
          mainTitle="Pige classique"
          subTitle="Visualisez et sélectionnez vos annonces"
        />
        <InfoBox />
      </header>

      <AdCardContainer
        ads={ads}
        type="ads"
        onPaginationChange={handlePaginationChange}
        onCheckAd={addItemToSelectedAd}
        onCardClick={loadActiveAd}
        checkedIds={selectedAds.map((m) => m.idIri)}
        adsPagination={adPagination}
      />
    </main>
  );
}

export default PieceworkPage;
